<template>
  <div class="page-container">
    <span class="parent-path">藥洗紀錄 / </span><span class="current-path">新增藥洗紀錄</span>
    <span class="page-title">新增藥洗紀錄</span>
    <div class="card-content">
      <a-form @submit.prevent="handleSubmit" class="company-form">

        <div class="section">
          <h2>執行資訊</h2>
          <div class="form-grid">
            <a-form-item :validateStatus="errors.date ? 'error' : ''" :help="errors.date">
              <a-label for="date">日期</a-label>
              <a-date-picker v-model:value="form.date" class="picker" placeholder="請選擇日期"/>
            </a-form-item>
            <a-form-item :validateStatus="errors.time ? 'error' : ''" :help="errors.time">
              <a-label for="time">時間</a-label>
              <a-time-picker v-model:value="form.time" format="HH:mm" class="picker" placeholder="請選擇時間"/>
            </a-form-item>
            <a-form-item :validateStatus="errors.user_id ? 'error' : ''" :help="errors.user_id">
              <a-label for="user">執行人員</a-label>
              <a-select v-model:value="form.user_id" placeholder="請輸入執行人員" style="display: block"
                        @change="handleChange">
                <a-select-option
                    v-for="item in users"
                    :key="item.id"
                    :value="item.id">
                  {{ item.last_name }}{{ item.first_name }}
                </a-select-option>
              </a-select>
            </a-form-item>
            <a-form-item :validateStatus="errors.note ? 'error' : ''" :help="errors.note">
              <a-label for="representative">備註</a-label>
              <a-textarea v-model:value="form.note" id="representative" type="text" placeholder="請填寫備註"/>
            </a-form-item>
          </div>
        </div>

        <div class="section">
          <h2>設備資訊</h2>
          <div class="form-grid">
            <a-form-item :validateStatus="errors.device_name ? 'error' : ''" :help="errors.device_name">
              <a-label for="lastName">設備名稱</a-label>
              <a-input v-model:value="form.device_name" id="lastName" type="text" placeholder="請輸入設備名稱"/>
            </a-form-item>
          </div>
        </div>

        <div class="form-actions">
          <a-button type="button" class="btn-cancel" @click="handleCancel">取消</a-button>
          <a-button html-type="submit" class="btn-submit">新增</a-button>
        </div>
      </a-form>
    </div>
  </div>
</template>

<script>
import {message} from "ant-design-vue";
import dayjs from "dayjs";

export default {
  inject: ['getSelectedCompany'],
  data() {
    return {
      users: [],
      form: {
        date: "",
        time: "",
        user_id: null,
        note: "",
        device_name: ""
      },
      errors: {
        date: "",
        time: "",
        user_id: "",
        note: "",
        device_name: ""
      }
    };
  },
  mounted() {
    this.selectedCompanyID = this.getSelectedCompany().id;
    this.users = this.getSelectedCompany().users
  },
  methods: {
    handleSubmit() {
      console.log("表單提交", this.form);

      for (let key in this.errors) {
        this.errors[key] = ""
      }

      let date = dayjs(this.form.date).format("YYYY-MM-DD");
      let time = dayjs(this.form.time).format("HH:mm");

      const token = localStorage.getItem('token');
      this.$axios.post('/api/cleaning-logs', {
        time: dayjs(`${date} ${time}`).utc().format("YYYY-MM-DD HH:mm"),
        user_id: this.form.user_id,
        organization_id: this.selectedCompanyID,
        note: this.form.note,
        device_name: this.form.device_name
      }, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      }).then(response => {
        console.log(response)
        message.success("已完成藥洗記錄新增")
        this.$router.go(-1)
      }).catch(error => {
        console.log(error);
        if (error.status === 401) {
          this.$router.push('/login');
        } else {
          console.log(error.response.data);
          let errors = error.response.data
          for (let key in errors) {
            this.errors[key] = errors[key]['message']
          }
          if (!this.form.date) this.errors.date = "未選擇日期"
          if (!this.form.time) this.errors.time = "未選擇時間"
        }
      });
    },
    handleCancel() {
      console.log("取消操作");
      this.$router.go(-1)
    },
  },
};
</script>

<style scoped>
.card-content {
  background-color: white;
  border-radius: 8px;
  width: 1024px;
  padding: 20px;
  margin-top: 28px;
}

h1 {
  font-size: 1.5em;
  margin-bottom: 1em;
}

.section {
  margin-bottom: 2em;
}

.section h2 {
  font-size: 1.2em;
  margin-bottom: 1em;
}

.form-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1em;
}

/*.form-group {*/
/*  display: flex;*/
/*  flex-direction: column;*/
/*}*/

label {
  font-size: 0.9em;
  margin-bottom: 0.5em;
  color: #333;
}

input {
  padding: 0.7em;
  font-size: 1em;
  border: 1px solid #ccc;
  border-radius: 4px;
}

input:focus {
  outline: none;
  border-color: #007bff;
  box-shadow: 0 0 5px rgba(0, 123, 255, 0.5);
}

.picker {
  display: block;
  padding: 10px 10px;
}

.form-actions {
  display: flex;
  justify-content: flex-end;
  gap: 1em;
}

.btn-cancel {
  background-color: #f8f9fa;
  color: #333;
}

.btn-submit {
  background-color: #007bff;
  color: white;
}

.btn-submit:hover {
  background-color: #0056b3;
}
</style>
